<template>
  <div class="fund-options">
    <h2 class="fund-options__title">Select a funding method</h2>
    <div class="fund-options__list">
      <FundOptionsCard type="Fund with bank transfer" @clicked="clicked" v-if="currency === 'NGN'" />
      <FundOptionsCard type="Fund with debit card" @clicked="clicked" />
      <FundOptionsCard type="P2P Transfers" @clicked="clicked" />
      <FundOptionsCard type="Crypto" @clicked="clicked" v-if="currency === 'USD'"/>
    </div>
  </div>
</template>

<script setup>
import FundOptionsCard from "@/components/wallet/FundOptionsCard";
import { computed, ref } from "vue";
import { useStore } from "vuex";

const store = useStore();
const emit = defineEmits(["options"]);
defineProps({
  currency: { type: String, default: () => "", required: false },
  isAllowed: { type: Boolean, default: () => false, required: true },
});

const fundMethod = ref("");

const currency = computed(() => store.getters["organisationModule/currency"]);
const smallLoading = computed(() => store.state.smallLoading);

const clicked = async (options) => {
  if (options === "Fund with bank transfer") {
    fundMethod.value = "virtual";
    const provider = currency.value === 'NGN' ? 'transactpay' : 'flutterwave';
    await store.dispatch("organisationModule/generateVirtualAccount", {
      currency: currency.value,
      provider: provider,
    });
  } else if (options === "Fund with debit card") {
    fundMethod.value = "fiat";
  } else if (options === "Crypto") {
    fundMethod.value = "crypto";
  } else if (options === "P2P Transfers") {
    fundMethod.value = "p2p";
  } 
  store.dispatch("organisationModule/setFundMethod", fundMethod.value);
  emit("options", options);
};
</script>

<style lang="scss" scoped>
.fund-options {
  padding: 8px 24px;

  &__title {
    font-family: 'DM Sans', sans-serif;
    font-size: 16px;
    font-weight: 500;
    color: #0F172A;
    margin: 0 0 20px 0;
  }

  &__list {
    display: flex;
    flex-direction: column;
  }
}
</style>
